module.exports = __webpack_public_path__ + "fonts/GothamPro-Light.71cd4f68.woff2";